<div class="app-header d-flex gap-3 align-items-center justify-content-between d-lg-none px-3 py-2">
  <button type="button" class="sidebar-icon-btn" (click)="toggleSidebar()" [attr.aria-expanded]="showSidebarOverlay"
    [attr.aria-label]="(showSidebarOverlay ? 'Collapse sidebar' : 'Expand sidebar') | translate">
    <img [src]="getExpandIcon()" alt="" width="24" height="24" />
  </button>
  <a routerLink="/dashboard" class="d-inline-block">
    <img [src]="logoUrl" alt="Del Monte Logo" width="44" height="41" style="width: 44px; height: auto" onerror="this.src='assets/images/dashboard/DelMonteLogo.png'" />
  </a>
</div>

<aside class="app-sidebar" [class.collapsed]="iconOnly" [class.sidebar-overlay]="showSidebarOverlay" [class.rtl]="isRTL"
  *ngIf="!isMobile || showSidebarOverlay" aria-label="Primary">
  <div class="sidebar-brand">
    <a [routerLink]="isSuperAdmin ? '/admin/dashboard' : '/dashboard'" class="brand-link">
      <img [src]="logoUrl" alt="Del Monte Logo" [width]="iconOnly ? 40 : 84" height="auto"
        onerror="this.src='assets/images/dashboard/DelMonteLogo.png'" />
    </a>
    <button type="button" class="expandicon" (click)="toggleSidebar()"
      [attr.aria-label]="(iconOnly ? 'Expand sidebar' : 'Collapse sidebar') | translate"
      [attr.aria-expanded]="!iconOnly">
      <img [src]="getExpandIcon()" alt="" width="24" height="24" />
    </button>
  </div>

  <nav class="sidebar-scroll" aria-label="Primary" (keydown)="onNavKeydown($event)">
    @if (!sidebarSections.length) {
    <p class="sidebar-empty">{{ 'No navigation items' | translate }}</p>
    }

    @for (section of sidebarSections; track section.label) {
    @for (item of section.items; track item.label || item.route) {
    @if (item.children) {
    <div class="nav-group" [class.open]="isGroupExpanded(item)">
      <button type="button" class="nav-link nav-group-toggle" [class.active]="isChildActive(item)"
        [class.justify-content-center]="iconOnly" [attr.data-group]="item.label"
        [attr.aria-expanded]="isGroupExpanded(item)" [attr.aria-controls]="getSafeId(item.label, 'submenu')"
        [title]="iconOnly ? (item.label | translate) : ''" (click)="toggleGroup(item)">
        <span class="nav-icon" aria-hidden="true"><i [ngClass]="item.icon"></i></span>
        @if (!iconOnly) {
        <span class="nav-label">{{ item.label | translate }}</span>
        <i class="bi nav-chevron" [class.bi-chevron-down]="isGroupExpanded(item)"
          [class.bi-chevron-right]="!isGroupExpanded(item)" aria-hidden="true"></i>
        }
      </button>

      <div class="submenu" [id]="getSafeId(item.label, 'submenu')" [attr.hidden]="isGroupExpanded(item) ? null : ''">
        @for (child of item.children; track child.route || child.label) {
        @if (!isExternal(child.route)) {
        <a [routerLink]="child.route" routerLinkActive="active"
          [routerLinkActiveOptions]="{ exact: exactLink(child.route) }" class="nav-link"
          (click)="onSidebarItemClick()">
          <span class="nav-icon" aria-hidden="true"><i [ngClass]="child.icon"></i></span>
          <span class="nav-label">{{ child.label | translate }}</span>
        </a>
        } @else {
        <a [href]="child.route" target="_blank" rel="noopener noreferrer" class="nav-link"
          (click)="onSidebarItemClick()">
          <span class="nav-icon" aria-hidden="true"><i [ngClass]="child.icon"></i></span>
          <span class="nav-label">{{ child.label | translate }}</span>
        </a>
        }
        }
      </div>
    </div>
    } @else if (!isExternal(item.route)) {
    <a [routerLink]="item.route" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: exactLink(item.route) }"
      class="nav-link" [class.justify-content-center]="iconOnly" [title]="iconOnly ? (item.label | translate) : ''"
      (click)="onSidebarItemClick()">
      <span class="nav-icon" aria-hidden="true"><i [ngClass]="item.icon"></i></span>
      @if (!iconOnly) {
      <span class="nav-label">{{ item.label | translate }}</span>
      }
    </a>
    } @else {
    <a [href]="item.route" target="_blank" rel="noopener noreferrer" class="nav-link"
      [class.justify-content-center]="iconOnly" [title]="iconOnly ? (item.label | translate) : ''"
      (click)="onSidebarItemClick()">
      <span class="nav-icon" aria-hidden="true"><i [ngClass]="item.icon"></i></span>
      @if (!iconOnly) {
      <span class="nav-label">{{ item.label | translate }}</span>
      }
    </a>
    }
    }
    }
  </nav>
</aside>

<div class="sidebar-bg-overlay" *ngIf="showSidebarOverlay" (click)="toggleSidebar()"></div>
